import { supabase } from '../lib/supabase';
import { config } from '../config/config';
import { applyDomainFilterToQuery } from '../hooks/useDomainQuery';

export interface Partner {
  id: string;
  tenant_id: string;
  name: string;
  logo_url?: string;
  description?: string;
  website_url?: string;
  project_type?: string;
  created_at: string;
  updated_at: string;
}

/**
 * Récupère tous les partenaires pour le tenant actuel
 */
export const fetchPartners = async () => {
  try {
    // Construire la requête avec filtrage domaine
    const query = supabase
      .from('partners')
      .select('*')
      .order('name');
    
    // Appliquer le filtre domaine avec fallback
    const filteredQuery = applyDomainFilterToQuery(query);
    
    const { data: partners, error } = await filteredQuery;

    if (error) {
      console.error('Erreur lors de la récupération des partenaires:', error);
      throw error;
    }

    return partners || [];
  } catch (error) {
    console.error('Erreur lors de la récupération des partenaires:', error);
    return [];
  }
};

/**
 * Ajoute un nouveau partenaire
 */
export const addPartner = async (partner: Omit<Partner, 'id' | 'created_at' | 'updated_at'>) => {
  try {
    const { data, error } = await supabase
      .from('partners')
      .insert([partner])
      .select();

    if (error) {
      console.error('Erreur lors de l\'ajout du partenaire:', error);
      throw error;
    }

    return data?.[0];
  } catch (error) {
    console.error('Erreur lors de l\'ajout du partenaire:', error);
    throw error;
  }
};

/**
 * Met à jour un partenaire existant
 */
export const updatePartner = async (id: string, partner: Partial<Partner>) => {
  try {
    const { data, error } = await supabase
      .from('partners')
      .update(partner)
      .eq('id', id)
      .select();

    if (error) {
      console.error('Erreur lors de la mise à jour du partenaire:', error);
      throw error;
    }

    return data?.[0];
  } catch (error) {
    console.error('Erreur lors de la mise à jour du partenaire:', error);
    throw error;
  }
};

/**
 * Supprime un partenaire
 */
export const deletePartner = async (id: string) => {
  try {
    const { error } = await supabase
      .from('partners')
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Erreur lors de la suppression du partenaire:', error);
      throw error;
    }

    return true;
  } catch (error) {
    console.error('Erreur lors de la suppression du partenaire:', error);
    throw error;
  }
};
